import { getAgeCTA3Template } from "../../shortcodes/templates";
import { getShortcodeWrapper, addShortcodeToEditor } from "../../shortodeAddition";

const ageCTA3Config = (tinymce, uuid, shortcodeOnClick) => {
  tinymce.activeEditor.windowManager.open({
    title: "Age CTA #3",
    body: {
      type: "panel",
      items: [
        {
          type: "selectbox",
          name: "count",
          label: "Buttons count",
          items: [
            { value: "3", text: "3" },
            { value: "4", text: "4" },
          ],
        },
        {
          type: "input",
          name: "url",
          label: "URL",
          placeholder: "https://domain.com",
        },
        {
          type: "selectbox",
          name: "openLink",
          label: "Open link in...",
          items: [
            { value: "_self", text: "Same window tab" },
            { value: "_blank", text: "New window tab" },
          ],
        },
        {
          type: "selectbox",
          name: "cornerRadius",
          label: "Corner radius",
          items: [
            { value: "0", text: "0" },
            { value: "2", text: "2" },
            { value: "4", text: "4" },
            { value: "6", text: "6" },
            { value: "8", text: "8" },
            { value: "12", text: "12" },
            { value: "16", text: "16" },
          ],
        },
        {
          type: "colorinput",
          name: "bgColor",
          label: "Button color",
        },
      ],
    },
    initialData: {
      bgColor: "#28b02b",
      cornerRadius: "8",
    },
    buttons: [
      {
        type: "cancel",
        name: "close",
        text: "Cancel",
      },
      {
        type: "submit",
        name: "submit",
        text: "Add",
        primary: true,
      },
    ],
    onSubmit: api => {
      const data = api.getData();
      const parentElement = tinymce.activeEditor.selection.getNode().nodeName.toLowerCase();

      const templateToAdd = getAgeCTA3Template({
        url: data.url,
        count: data.count,
        tab: data.openLink,
        bgColor: data.bgColor,
        cornerRadius: data.cornerRadius,
      });

      const shortcodeWrapper = getShortcodeWrapper(uuid, shortcodeOnClick, templateToAdd);
      addShortcodeToEditor(shortcodeWrapper, uuid, parentElement, api);
      api.close();
    },
  });
};

export { ageCTA3Config };
